import { Observable } from 'rxjs';
import { DataSourceAdapter } from './data-source-adapter.interface';

/**
 * Adapter for Observable data sources.
 * Use when data updates reactively (e.g., from a BehaviorSubject or store).
 *
 * Sorting and filtering are handled client-side by MatTableDataSource.
 * Table re-renders automatically when the observable emits new data.
 *
 * @example
 * ```ts
 * // In component:
 * items$ = this.store.select(selectItems);
 *
 * // In template (auto-resolved):
 * [dataSource]="items$"
 *
 * // Or manually:
 * const adapter = new ObservableDataSource(items$);
 * ```
 *
 * @template T - Row data type
 */
export class ObservableDataSource<T> implements DataSourceAdapter<T> {
  readonly type = 'observable' as const;

  constructor(private readonly data$: Observable<T[]>) {}

  connect(): Observable<T[]> {
    return this.data$;
  }

  disconnect(): void {
    // No cleanup needed - observable lifecycle managed by subscriber
  }
}
